import { makeStyles } from "@material-ui/core"
import { themeVariables } from "../../MUI"

export const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12

  },
  certificatePageWrapper: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    letterSpacing: '.02em',

    '& h3': {
      fontSize: '18px',
      fontWeight: 600
    }
  },
  container: {
    maxWidth: 685,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    margin: '0 auto'
  },
  layoutFooter: {
    margin: '0 auto'
  },
  titleWrapper: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    flexDirection: 'row',
  },
  cert: {
    width: 96,
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: themeVariables.palette.primary.main,
    backgroundColor: themeVariables.palette.grey.A400
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    '& > span': {
      marginTop: 6,
      color: themeVariables.palette.grey[600],
      fontSize: '15px'
    }
  },
  status: {
    position: 'absolute',
    left: 0,
    bottom: '-16px',
    opacity: 0,
    transition: '.3s opacity ease-out',

    '&.success': {
      color: themeVariables.palette.success.main,
      opacity: 1,
    },
    '&.error': {
      color: themeVariables.palette.error.main,
      opacity: 1,
    },
  },
  input: {
    position: 'relative',
    '&.success': {
      paddingBottom: 10,
    },
    '&.error': {
      paddingBottom: 10,
      '@media(max-width: 375px)': {
        paddingBottom: 30,
      }

    }
  },
  footer: {
    paddingTop: 16,
    textAlign: 'right'
  },
  row: {
    paddingBottom: '1rem'
  },
  courseName: {
    lineClamp: 2,
    display: 'box',
    boxOrient: 'vertical',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },

  info: {
    transition: '.3s height ease-out',
    overflow: 'hidden',
  },
  valideInput: {
    '& fieldset': {
      borderColor: themeVariables.palette.success.main
    }
  },
  semiBold: {
    '& span': {
      fontWeight: 600,
      position: 'relative',
      bottom: 1,
      whiteSpace: 'nowrap',
      width: 181
    },

    '@media(max-width: 768px)': {
      marginBottom: '10px !important'
    }
  },
  statusRow: {
    transition: 'none',
    '&.success': {
      marginBottom: '30px !important',
    },
    '&.error': {
      marginBottom: '16px !important',
    }
  }
}))